<span *ngIf="dossier">
  <app-edit-stepper-content [dossier]="dossier" [retourAuthorized]="true" [openComment]="openComment"></app-edit-stepper-content>
</span>
